import * as yup from 'yup';

import {
  emailSchema,
  passwordSchema,
  userNameSchema,
  userNameOrEmailSchema,
} from './shared-schema';

/**
 * Schema for login feature and login verification in the backend.
 * See [yup](https://github.com/jquense/yup).
 */
const schemaLogin = yup.object().shape({
  userNameOrEmail: userNameOrEmailSchema,
  password: passwordSchema,
});

const schemaForgotPassword = yup.object({
  email: emailSchema(true),
});

const schemaSignup = yup.object().shape({
  email: emailSchema(false),
  userName: userNameSchema(true),
  password: passwordSchema,
});

export { schemaForgotPassword, schemaLogin, schemaSignup };
